/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ColumnOut {
  id: string;
  label: string;
  type: string;
  ops: string[];
  sortable: boolean;
  custom_property_id?: string | null;
}
